import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'mf-collect-order-grid-page',
  templateUrl: './collect-order-grid-page.component.html',
  styleUrls: ['./collect-order-grid-page.component.scss'],
})
export class CollectOrderGridPageComponent {}
